import React from "react";
import { ShapeContext } from "./ShapeProvider";

export const useShape = () => {
  const context = React.useContext(ShapeContext);
  if (!context) {
    throw new Error("useShape must be used within a ShapeProvider");
  }
  return context;
};
